import React from 'react';
import CountDownClock from './CountDownClock';
import { Typography, useTheme } from '@material-ui/core';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import { useDispatch, useSelector } from 'react-redux';
import { setTopBannerOpen } from 'src/store/Dashboard/actions';
import postOnSlack from 'src/core/postOnSlack';
import {
  AIRBTICS_PRO_BANNER_LOCALSTORAGE_VARIABLE,
  TOP_BANNER_PADDING,
  TOP_BANNER_PADDING_MOBILE,
} from 'src/const';
import { useMediaQuery } from '@mui/material';

import './style.scss';
import { COLOR_SUCCESS, COLOR_WARNING } from 'src/colors';

const AirbticsProBanner = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.dashboard.user.email);
  const isTablet = useMediaQuery(theme.breakpoints.down('sm'));
  const ismobile = useMediaQuery(theme.breakpoints.down(630));

  // Commenting it 
  // const handleDownloadButtonClick = async () => {
  //   if (user && user !== 'Trial' && !localStorage.getItem('airbtics-pro-sample-data-downloaded')) {
  //     try {
  //       const slackResponse = await postOnSlack(
  //         'tracker-airbtics-pro',
  //         `${user} downloaded the airbtics pro sample data from the app!`
  //       );
  //       if (slackResponse) {
  //         localStorage.setItem('airbtics-pro-sample-data-downloaded', 'true');
  //       }
  //     } catch (err) {
  //       console.log('Error in slack from banner: ', err);
  //     }
  //   }
  // };

  return (
    <div
      className="banner-root-div"
      style={{
        height: ismobile ? TOP_BANNER_PADDING_MOBILE : TOP_BANNER_PADDING,
      }}
    >
      <img
        src="https://cdn.leonardo.ai/users/2c3f2f69-cc5c-48cc-ac85-949d0c24d3c5/generations/baf0cbc3-9806-4df6-90b6-1fa27eb69beb/variations/Default_svg_icon_background_consist_of_small_white_icon_1_baf0cbc3-9806-4df6-90b6-1fa27eb69beb_1.jpg"
        className="banner-bg-img"
      />
      <div className="banner-text-container">
        <Typography variant={'h5'}>🎉</Typography>
        <Typography
          variant={isTablet ? 'body2' : 'h6'}
          className="banner-text"
          style={{
            width: ismobile ? '70%' : 'auto',
          }}
        >
          GET COUNTRY PLAN! Get it at 10% off. <span style={{color:COLOR_WARNING, marginLeft:"5px"}}>Code: COUNTRY10</span>  
          {/* <span> here! </span> */}
          <a
            href="https://app.airbtics.com/airbnb-data?payment-plan=country&payment-duration=monthly"
            target="_blank"
          >
            <span>Get Now</span>{' '}
          </a>
          Time left: 
          <CountDownClock />
        </Typography>
        <div
          style={{ cursor: 'pointer' }}
          onClick={_ => {
            window.localStorage.setItem(AIRBTICS_PRO_BANNER_LOCALSTORAGE_VARIABLE, 'true');
            dispatch(setTopBannerOpen(false));
          }}
        >
          <CloseRoundedIcon />
        </div>
      </div>
    </div>
  );
};

export default AirbticsProBanner;
